/** In-app help: HustlePop marketing site (`/help` + hash sections). */
export const HUSTLEPOPS_SITE = "https://www.hustlepops.com";
export const HUSTLEPOPS_HELP = `${HUSTLEPOPS_SITE}/help`;

export const hustlepopsHelpUrl = {
  schedule: `${HUSTLEPOPS_HELP}#popup-schedule`,
  /** Display rules — triggers overview (“Learn more” intro). */
  triggersOverview: `${HUSTLEPOPS_HELP}#popup-triggers`,
  exitIntent: `${HUSTLEPOPS_HELP}#exit-intent`,
  clickTrigger: `${HUSTLEPOPS_HELP}#click-trigger`,
  hoverTrigger: `${HUSTLEPOPS_HELP}#hover-trigger`,
  discountCoupon: `${HUSTLEPOPS_HELP}#discount-coupon`,
} as const;
